import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { formatValue } from '@ts-core/utils/dataTableUtils';

import TSTable, {
  DeleteButtonTableCell,
  DateTableCell,
} from '@ts-core/components/Table';

const AssignmentAnswersTable = (props) => {
  const intl = useIntl();
  const {
    assignment,
    answers,
    loading,
    onFilterAnswers,
    onDeleteAnswer,
    onSelectAnswer,
    onGetXlsxData,
  } = props;

  const columns = useMemo(() => {
    const result = [
      {
        Header: intl.formatMessage({ id: 'studentsTable.column.name' }),
        value: intl.formatMessage({ id: 'studentsTable.column.name' }),
        accessor: 'student.name',
        sortable: true,
      },
      {
        Header: intl.formatMessage({ id: 'studentsTable.column.email' }),
        value: intl.formatMessage({ id: 'studentsTable.column.email' }),
        accessor: 'student.email',
        sortable: true,
      },
    ];

    if (answers.some((s) => s.student.group)) {
      result.push({
        Header: intl.formatMessage({ id: 'assignmentResultsTable.group' }),
        value: intl.formatMessage({ id: 'assignmentResultsTable.group' }),
        accessor: 'student.group.name',
        id: 'student.group.name',
        sortable: true,
        filterable: true,
      });
    }

    result.push({
      Header: 'Fecha y Hora',
      value: 'Fecha y Hora',
      accessor: 'finishedAt',
      sortable: true,
      valueTransformer: (value) => (
        <DateTableCell date={value} format="DD/MM/YYYY hh:mm" />
      ),
    });

    result.push({
      Header: intl.formatMessage({ id: 'result' }),
      value: intl.formatMessage({ id: 'result' }),
      accessor: 'score',
      valueTransformer: (value) =>
        formatValue(value, assignment?.stats?.maxScore),
      sortable: true,
    });
    result.push({
      Header: '',
      accessor: '_id',
      exportable: false,
      valueTransformer: (value, column, answer) => (
        <DeleteButtonTableCell
          message={intl.formatMessage(
            {
              id: 'dialog.removeAssignmentAnswer',
            },
            { student: answer.student.name }
          )}
          item={answer}
          onConfirm={onDeleteAnswer}
        />
      ),
    });

    return result;
  }, [intl, answers, onDeleteAnswer, assignment]);

  return (
    <TSTable
      title={intl.formatMessage({ id: 'assignment.answers' })}
      data={answers}
      loading={loading}
      columns={columns}
      onSelectRow={onSelectAnswer}
      onSearch={onFilterAnswers}
      getDataToExport={onGetXlsxData}
      allowDownloadAsXLSX
      xlsxFileName={assignment.name}
      emptyMessage={intl.formatMessage({
        id: 'assignmentAnswersTable.emptyMessage',
      })}
    />
  );
};

AssignmentAnswersTable.propTypes = {
  assignment: PropTypes.object,
  answers: PropTypes.array,
  loading: PropTypes.bool,

  onFilterAnswers: PropTypes.func,
  onDeleteAnswer: PropTypes.func,
  onSelectAnswer: PropTypes.func,
  onGetXlsxData: PropTypes.func,
};

AssignmentAnswersTable.defaultProps = {
  assignment: {},
  answers: [],
  loading: false,

  onFilterAnswers() {},
  onDeleteAnswer: undefined,
  onSelectAnswer: undefined,
  onGetXlsxData: undefined,
};

export default AssignmentAnswersTable;
